const messages = {
  en: {
    tab: 'Open in new tab'
  },
  'es-ud': {
    tab: 'Abrir en nueva pestaña'
  },
  es: {
    tab: 'Abrir en nueva pestaña'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/PopoutIframeModal/messages.js